<template>
  <IntroVideoWorkspace type="story" />
</template>

<script>
import IntroVideoWorkspace from '../introVideoWorkspace';

export default {
  components: {
    IntroVideoWorkspace,
  },
};
</script>
